import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const ddK8SFrontendPlugin = createPlugin({
  id: 'dd-k8s-frontend',
  routes: {
    root: rootRouteRef,
  },
});

export const DdK8SFrontendPage = ddK8SFrontendPlugin.provide(
  createRoutableExtension({
    name: 'DdK8SFrontendPage',
    component: () =>
      import('./components/ExampleComponent').then(m => m.ExampleComponent),
    mountPoint: rootRouteRef,
  }),
);
